module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1b1Ea"))).then(() => parcelRequire('37nVf'));